// ========= production ========
// export const API_BASE_URL = "https://apiv2.cookandchef.in/api/v1/"

// ========= staging =========
// export const API_BASE_URL = 'https://testapi203.cookandchef.in/api/v1'

// ========== development =========
// export const API_BASE_URL = 'http://localhost:5001/api/v1'
export const API_BASE_URL = process.env.REACT_APP_API_URL;

/** Root host for routes outside /api/v1 (e.g. /api/resume/*). */
export const API_ROOT_URL = (API_BASE_URL || "").replace(/\/api\/v1\/?$/, "");

export const RESUME_API_PATHS = {
  uploadDp: `${API_ROOT_URL}/api/resume/upload-dp`,
  parse: `${API_ROOT_URL}/api/resume/parse`,
  persist: `${API_ROOT_URL}/api/resume/persist`,
};

export const PUBLIC_API_PATHS = {
  chefs: `${API_ROOT_URL}/api/public/chefs`,
  jobs: `${API_ROOT_URL}/api/public/jobs`,
  jobDetail: (slugOrId) =>
    `${API_ROOT_URL}/api/public/jobs/${encodeURIComponent(slugOrId)}`,
  houseCookJobs: `${API_ROOT_URL}/api/public/house-cook-jobs`,
};

export const LOCATION_API_PATHS = {
  suggest: `${API_ROOT_URL}/api/location/suggest`,
  suggestLocal: `${API_ROOT_URL}/api/location/suggest-local`,
  resolve: `${API_ROOT_URL}/api/location/resolve`,
};

export const GOOGLE_SEARCH_APIKEY = "AIzaSyCMMDmDdRD71ao1oc67wqhOGJ8k1D_JuhY";
// export const GOOGLE_SEARCH_APIKEY = "AIzaSyD1YWqeblqJSAimHX_kEiEzQ2lP2_EDTv8";

export const API_PATHS = {
  //auth
  cookRegister: "/cook/signup",
  cookverifyOtp: "/cook/signup/verifyOtp",
  cookLogin: "/cook/login",
  resendotp: "/cook/signup/resendOtp",
  employerRegister: "/employer/signup",
  employerRegisterV2: "/employer/signup-v2",
  employerVerifyOtp: "/employer/signup/verifyOtp",
  employerLogin: "/employer/login",
  employerResendotp: "/employer/signup/resendOtp",
  employerReferral: "/employer/referral",
  employerWallet: "/employer/wallet",
  verifyemail: "/employer/login/verifyEmail",
  cookverifyemail: "/cook/login/verifyEmail",
  clientverifyemail: "/employer/login/verifyEmail",
  changeEmail: "/employer/login/changeEmail",
  cookchangeEmail: "/cook/login/changeEmail",
  clientchangeEmail: "/employer/login/changeEmail",
  changemobile: "/employer/login/changemobilenumber",
  clientcheckwatsapp: "/employer/check/whatsappNumber",
  verifyotpchangemobile: "/employer/login/updateMobile/verifyOtp",
  changewatsapp: "/employer/edit/whatsappNumber",
  verifywatsappotp: "/employer/verify/whatsappOtp",
  cookchangemobile: "/cook/login/changemobilenumber",
  cookchangeWhatsap: "/cook/edit/whatsappNumber",
  cookcheckwatsappnumber: "/cook/check/whatsappNumber",

  cookverifymobileotp: "/cook/login/updateMobile/verifyOtp",
  cookverifywatsappotp: "/cook/verify/whatsappOtp",
  changepassword: "/common/login/changePassword",
  contactprivacy: "/common/edit/privacy-settings",
  billingDetailsFetchV2: "/common/billingDetails/v2",
  billingDetailsEditV2: "/common/billingDetails/v2/edit",
  employersignupchangemobile: "/employer/signup/changemobilenumber",
  cooksignupchangemobile: "/cook/signup/changemobilenumber",


  //cook apis
  getProfile: "/cook/fetch/profile",
  getProfileV2: "/cook/fetch/profile-v2",
  getViewEmployerProfile: "/cook/view-employer/fetch",
  getViewEmployerProfileV2: "/cook/view-employer/fetch-v2",
  getViewProfile: "/cook/view-profile",
  editProfile: "/cook/edit/profile",
  editPartyProfile: "/cook/edit/profile/partycook",
  editHouseProfile: "/cook/edit/profile/houseCook",
  editHouseProfileV2: "/cook/edit/profile/houseCook-v2",
  editChefProfile: "/cook/edit/profile/chef-v3",
  editChefProfileV2: "/cook/edit/profile/chef-v2",
  getCookSkills: "/cook/get-cook-skills",
  createCookSkill: "/cook/cook-skills",
  getCookSkillsV2: "/cook/get-cook-skills-v2",
  createCookSkillV2: "/cook/cook-skills-v2",
  getcookplan: "/cook/cookplans/fetch",
  cookinitiatepayments: "/cook/payment/initiate",
  cookconfirmpayments: "/cook/payment/confirm",
  uploadFileCook: API_BASE_URL + "/cook/upload",
  uploadProfileImageCook: API_BASE_URL + "/cook/upload/profile-image",
  uploadCvCook: API_BASE_URL + "/cook/upload/cv",
  forgotpassword: "/cook/signup/forgotPassword",
  updatepassword: "/cook/signup/forgotPassword/verifyOtp",
  findjobs: "/cook/find-jobs",
  cookplanHistory: "/cook/payments/history",
  editcatering: "/cook/edit/profile/catering-v2",
  getcookPlans: "/cook/cookplans/fetch",
  appliedjobs: "/cook/applied-chef-jobs/fetch",
  findeventcook: "/cook/find-events",
  findeventcookV2: "/cook/find-events-v2",
  shortlistEvent: "/cook/shortlist-event",
  shortlistHousejob: "/cook/shortlist-housecook-job",
  removeshortlisthousejob: "/cook/remove-shortlist-housecook-job",
  shortlistjob: "/cook/shortlist-chef-job-v2",
  removeshortlistjob: "/cook/remove-shortlist/application",
  viewjobdetails: "/cook/view-job-v3",
  employerjobdetails: "/employer/jobpost/fetch",
  cookmobieactivity: "/cook/store/activity-logs",
  eventdetails: "/cook/view-event",
  eventdetailsV2: "/cook/view-event-v2",
  appliedevents: "/cook/applied-events/fetch",
  findhousejobs: "/cook/find-housecook-jobs-v5",
  findhousejobsV2: "/cook/find-housecook-jobs-v2",
  cookcancelapplication: "/cook/cancel/application",
  cookapplyjob: "/cook/apply-chef-job",
  applyevent: "/cook/apply-event",
  disablecookaccount: "/cook/disable-account",
  enablecookaccount: "/cook/enable-account",
  deletecookaccount: "/cook/delete-account/request/add",
  cancelcookdeleterequest: "/cook/revoke-delete-request",
  housecookjobdetails: "/cook/view-housecook-job-v2",
  applyhousecookjob: "/cook/apply-housecook-job",
  updateLastLogin: "/cook/update/last-login-time",
  generateResume: "/cook/generate-resume",
  getDashboardDataCook: "/cook/dashboard",
  appliedhousejobs: "/cook/applied-housecook-jobs/fetch",
  cookreportjob: "/cook/report/submit",
  getresumetemplates: "/cook/templates-list/fetch",
  updatecookWeavyid: "/cook/update/WeavyId",
  shortlistedjobs: "/cook/shortlisted-chef-jobs/fetch-v2",
  shortlistedEvents: "/cook/shortlisted-events/fetch",
  shortlistedHouseJobs: "/cook/shortlisted-housecook-jobs/fetch",
  changeRole: "/cook/change/role",
  employerRating: "/cook/store/employer-rating",

  getSharedprofile: "/employer/share/cookProfiles/fetch",
  getsharedprofileDetails: "/employer/shared/cookProfile/viewDetails",
  cookreachoutactivities: "/cook/fetch/reachout-activities",
  //client apis
  getemployerProfile: "/employer/fetch/profile-v2",
  getemployerProfileV2: "/employer/fetch/profile-v2",
  editemployerProfile: "/employer/edit/profile",
  getrequirement: "/employer/requirements/fetch",
  getrequirementV2: "/employer/requirements/fetch-v2",
  addrequirement: "/employer/requirements/add",
  saverequirementV2: "/employer/requirements/save-v2",
  getclientplans: "/employer/clientplans/fetch",
  getclientplansV2: "/employer/clientplans/fetch-v2",
  getClientPointsActiveV2: "/employer/clientpoints/active-v2",
  postEvents: "/employer/clientEvents/create",
  editEvents: "/employer/clientEvents/edit",
  editEventsV2: "/employer/clientEvents/edit-v2",
  getEvents: "/employer/clientEvents/fetch",
  clientLongplan: "/employer/employerplans/fetch?plantype=2",
  clientShortplan: "/employer/employerplans/fetch?plantype=1",
  disableaccount: "/employer/disable-account",
  enableaccount: "/employer/enable-account",
  uploadFileClient: API_BASE_URL + "/employer/upload",
  uploadProfileImageClient: API_BASE_URL + "/employer/upload/profile-image",
  clientPlanHostory: "/employer/clientsplan/payment/history",
  clientPlanHistoryV2: "/employer/clientsplan/payment/history-v2",
  deleteaccount: "/employer/delete-account/request/add",
  canceldeleterequest: "/employer/revoke-delete-request",
  updateLastLoginEmployer: "/employer/update/last-login-time",
  houseinterests: "/employer/housejob-applications-list/fetch-v2",
  houseinterestdetails: "/employer/housejob-application/view-v2",
  housejobApplicationEdit: "/employer/housejob-application/edit",
  updateemployerWeavyid: "/employer/update/WeavyId",


  //config
  getCuisine: "/common/fetch/cusiniesList",
  cuisineTypeaheadV2: "/common/cuisines/v2/typeahead",
  getQualification: "/dropdown/fetch-qualification",
  getLanguages: "/dropdown/fetch-languages",
  getState: "/dropdown/fetch-province",
  getFaq: "/common/faqs/fetch",
  getFaqV2: "/common/faqs/fetch/v2",

  //empoyer
  postjob: "/employer/jobpost/create",
  postjobV2: "/employer/jobpost/create-v2",
  editjob: "/employer/jobpost/edit",
  editjobV2: "/employer/jobpost/edit-v2",
  getjob: "/employer/jobpost/fetch",
  getemployerLongplan: "/employer/employerplans/fetch?plantype=2",
  getemployerShortplan: "/employer/employerplans/fetch?plantype=1",
  findchef: "/employer/find-chefs-v3",
  findchefV2: "/employer/find-chefs-v2",
  findchefFreshers: "/employer/find-chefs-freshers",
  chefProfileUnlock: "/employer/chef-profile/unlock",
  chefNotInterested: "/employer/chef-profile/not-interested",
  shortlistcook: "/employer/shortlist/cook-profile",
  shortlistcookV2: "/employer/shortlist/cook-profile-v2",
  removeshortchef: "/employer/shortlist-profile/delete",
  removeshortchefV2: "/employer/shortlist-profile/delete-v2",
  viewshortlistchef: "/employer/shortlisted-profiles/fetch",
  viewshortlistchefV2: "/employer/shortlisted-profiles/fetch-v2",
  viewchefDetails: "/employer/cook-details/fetch",
  viewchefDetailsV2: "/employer/cook-details/fetch-v2",
  cookRatingsV2: "/employer/cook-ratings/fetch-v2",
  employerplanHistory: "/employer/employerplan/payment/history",
  geteventrequests: "/employer/event-applications-list/fetch",
  uploadFileEmployer: API_BASE_URL + "/employer/upload",
  uploadProfileImageEmployer: API_BASE_URL + "/employer/upload/profile-image",
  eventrequeststatus: "/employer/event-application/edit",
  employerreachoutactivities: "/employer/fetch/reachout-activities",
  employerreachoutactivitiesV2: "/employer/fetch/reachout-activities-v2",

  getapplicationsReceived: "/employer/job-applications-list/fetch",
  getapplicationsReceivedV2: "/employer/job-applications-list/fetch-v2",
  jobAiMatchesSummary: "/employer/job-ai-matches/summary",
  jobAiMatchesFetch: "/employer/job-ai-matches/fetch",
  jobAiMatchesGenerateMore: "/employer/job-ai-matches/generate-more",
  jobAiMatchesDislike: "/employer/job-ai-matches/dislike",
  employerapplicationstatus: "/employer/job-application/edit",
  employercheckoutinitiate: "/employer/employerplan/payment/initiate",
  employercheckoutinitiateV2: "/employer/employerplan/payment/initiate-v2",
  employercheckoutinitiateV3: "/employer/employerplan/payment/initiate-v3",
  employercheckoutconfirm: "/employer/employerplan/payment/confirm",
  employercheckoutconfirmV2: "/employer/employerplan/payment/confirm-v2",
  employerCouponValidate: "/employer/employerplan/coupon/validate",
  employermobieactivity: "/employer/store/activity-logs",
  viewApplicationDetail: "/employer/job-application/view",
  viewApplicationDetailV2: "/employer/job-application/view-v2",
  vieweventrequestdetails: "/employer/event-application/view",
  purchageassistance: "/employer/employerplan/supportAssistance/payment/initiate",
  findcatering: "/employer/find-caterings-v2",
  findpartycook: "/employer/find-party-cooks-v2",
  findhousecook: "/employer/find-house-cooks",
  findhousecookV2: "/employer/find-house-cooks-v2",
  getDashboardData: "/employer/dashboard",
  getDashboardDataV2: "/employer/dashboard/v2",
  getDashboardDataV3: "/employer/dashboard/v3",
  reportchefprofile: "/employer/report/submit",
  employerplanpurchase: "/employer/employerplan/supportAssistance/payment/initiate",
  cookrating: "/employer/store/cook-rating",

  //weavy
  //   weavyId : "009c9ffe18594d13bacdea6dd57d3b41", //weavyID 
  // weavyKey :"wys_9Xq10KMQQrFJXzhhNO8QTUuz49pBcB1NN1tQ", //weavyKey
  weavyId: "8cfaa74deeb14900be7d2e7c222c6490", //weavyID 
  weavyKey: "wys_pW7fvZOVnpA3dr3sC4tzXIRNjqwH8f0O2xHG", //weavyKey
  othersweavyId: "/common/chat/initiateWeavyId",
  chatGetRoom: "/chat/get-room",
  chatInitUser: "/chat/init-user",
  //payments


  employerinitiatepayments: "/employer/employerplan/payment/initiate",
  clientinitiatepayments: "/employer/clientplan/payment/initiate",
  gepaymentkey: "/common/fetch/config?rzp=1",



  //website data
  topChefs: "/common/website/fetch/topchefs",
  topJobs: "/common/website/fetch/topjobs",
  testimonial: "/common/website/fetch/testimonials",
  contactUs: "/common/contactUs/submit/ticket",
  getAdvertisements: "/cook/advertisement-list/fetch",
  getemployerAdvertisements: "/employer/advertisement-list/fetch",
  getwebsiteCookslisthome: "/common/website/fetch/cookslist",
  googlemapsapikey: "AIzaSyCMMDmDdRD71ao1oc67wqhOGJ8k1D_JuhY"

};
